import { Controller } from 'stimulus';

export default class extends Controller {

  connect() {
    let param_name = ''
    if(this.element.name == 'benefit[company_id]') {
      param_name = 'new_company_name';
    } else if(this.element.name == 'benefit[vendor_user_id]') {
      param_name = 'new_vendor_user_email';
    } else if (this.element.name == 'benefit[brand_name]') {
      param_name = 'new_brand_name';
    }
      
    new TomSelect(this.element, {
      create: false,
    });
  }

}